import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { Avatar } from 'library';
import { JobModel } from '../NewsfeedModels';
import theme from 'theme';

const JobCardAvatarBase = ({ job, caption }: { job: JobModel; caption?: React.ReactNode }) => {
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const size = smDown ? 45 : 60;
    const styles = {
        image: {
            borderRadius: 50,
            width: size,
            height: size,
        },
    };

    return (
        <Grid style={{ marginBottom: 12, marginRight: 8 }}>
            <Grid container direction="row" justify="center">
                {job.family.user.image?.length > 0 ? (
                    <img src={job.family.user.image[0].image} alt="User Profile" style={styles.image} />
                ) : (
                    <Avatar index={job.family.user.id % 5} style={styles.image} />
                )}
            </Grid>
            {caption}
        </Grid>
    );
};

export default JobCardAvatarBase;
